import React, { useEffect, useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import { Sun, Moon } from 'lucide-react';

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // Avoid hydration mismatch by waiting for mount
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return <div className="w-6 h-6" />;
  }

  return (
    <button
      onClick={toggleTheme}
      className="theme-toggle relative inline-flex items-center justify-center w-10 h-10 rounded-full bg-transparent hover:bg-gray-100 dark:hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-primary transition-colors duration-300"
      aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
    >
      <div className="theme-icon-container">
        <Sun 
          className={`theme-icon ${theme === 'light' ? 'visible' : ''}`} 
          size={22} 
          strokeWidth={2} 
        />
        <Moon 
          className={`theme-icon ${theme === 'dark' ? 'visible' : ''}`} 
          size={22} 
          strokeWidth={2} 
        />
      </div>
    </button>
  );
};

export default ThemeToggle;